/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$('.testimonial-block__text').on('click', '.readmore', function (event) {
      event.preventDefault();
      $(this).prev(".complete").show();    	      
      $(this).hide();    	
	});
     $('.testimonial-block__text').on('click', '.readless', function (event) {
      	event.preventDefault();       
     	$(this).parent(".complete").hide();    	
        $(this).parent(".complete").next('.readmore').show();  
        $(this).parent(".complete").prev('.teaser').show();           
	});


  // jQuery(document).ready(function($){

  //   var imagSection = $('.pdp-page-class  .image-section');
  //  imagSection.each(function() {
  //    var thisDiv = $( this );
  //  var visibleImagewarp = thisDiv.find('.pdp-page-class  .visible-imagewarp');
  //    var visibleImagewarpLength = visibleImagewarp.length;
  //     if(visibleImagewarpLength < 1) {
  //      thisDiv.hide();
  //    }
  // });
    
  // })


let addBtn1 = document.querySelector('.product__zoom-button');
let addBtn2 = document.querySelector('.pswp__button--close');

let product__media = document.querySelector('.product__media');
 if(addBtn1){
 addBtn1.addEventListener('click', function(e) {
  product__media.classList.add('main-btn');
});
 }
 if(addBtn2){
  addBtn2.addEventListener('click', function(e) {
  product__media.classList.remove('main-btn');
});
 }

// Personalize message JS

  if (window.location.href.indexOf("open=note") > -1) {
      setTimeout(function(){
    document.querySelector('[name="note"]').placeholder='Write your personalized message here.';
    document.querySelector('#order-note-toggle').click();
  },1000)
  
    }
  document.querySelector("#closeFreeGwpList").addEventListener('click', function(e) {
  document.querySelector("#freeGwpList").classList.remove('open'); 
    });

function openGiftpopup(){
  document.querySelector("#freeGwpList").classList.add('open'); 
}
async function personalizedAdd2Cart(id='') {
var personalizedMessage = document.querySelector('[name="enablePersonalizedMessage"]');
if(personalizedMessage.checked)
{

  personalizedMessage.setAttribute('disabled', 'disabled');
  document.querySelectorAll('.personalAdd2Cart').forEach(function(btn){
    btn.classList.add('disabled');
    btn.querySelector('.loader-button__loader').removeAttribute('hidden');
  })
   if(id!=''){ var variantId= id; } else { var variantId= personalizedMessage.dataset.product; }
  console.log("variantId",variantId)
  const addFreeProduct =  await fetch('/cart/add.js', {
    body: JSON.stringify({ id:variantId, quantity:1,properties:{'_personalizedProduct':'true'}}),
    credentials: "same-origin",
    method: "POST",
     headers: {
      "Content-Type": "application/json"
    }
  });
  if (window.location.href.indexOf("cart") > -1) {
   window.location.href='/cart?open=note';
  
    }
   await fetch('/cart.js').then(async (response2) => {
       cartContent = await response2.json();
      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: cartContent
        }
      }));
        
     })

    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent
        }
      }));
    personalizedMessage.removeAttribute('disabled');
  setTimeout(function(){
    document.querySelector("#freeGwpList").classList.remove('open'); 
    document.querySelector('[aria-controls="mini-cart"]').click();
    document.querySelector('[name="note"]').placeholder='Write your personalized message here.';
    document.querySelector('#order-note-toggle').click();
    document.querySelectorAll('.personalAdd2Cart').forEach(function(btn){
    btn.classList.remove('disabled');
    btn.querySelector('.loader-button__loader').setAttribute('hidden','');
  })
  },1500)
  
 }
 else {
      personalizedMessage.setAttribute('disabled', 'disabled');
      document.querySelector('.personalizedLoading').style.display='block';
      const clearCart = await fetch('/cart/change.js', {
      body: JSON.stringify({ id:personalizedMessage.dataset.product, quantity:0 }),
      credentials: "same-origin",
      method: "POST",
      headers: {
      "Content-Type": "application/json"
     }
     });
     var cartContent = await clearCart.json();
  if (window.location.href.indexOf("cart") > -1) {
  window.location.href='/cart';
    }
     document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
        cart: cartContent
        }
      }));
     personalizedMessage.removeAttribute('disabled');
 }

}
